import { useGetDebugInfo } from "@/api/queries/logins";
import type { LoginItemType } from "@/api/queries/logins/types";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Bug, Loader2 } from "lucide-react";
import { useState } from "react";
import JsonView from "react18-json-view";

interface DebugDialogProps {
  loginItem: LoginItemType;
}

export const DebugDialog = ({ loginItem }: DebugDialogProps) => {
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useGetDebugInfo(loginItem.id, open);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <Button data-testid="debug-dialog-trigger-btn" className="w-full justify-start gap-2">
          <Bug className="size-4" />
          Debug
        </Button>
      </DialogTrigger>

      <DialogContent className="max-w-4xl w-full md:min-w-2xl">
        <DialogHeader>
          <DialogTitle>Debug</DialogTitle>
        </DialogHeader>
        <div
          style={{
            maxHeight: "calc(100vh - 100px)",
          }}
          className="overflow-auto p-4 flex flex-col gap-4"
        >
          {isLoading ? (
            <div className="flex h-40 items-center justify-center">
              <Loader2 className="size-6 animate-spin text-muted-foreground" />
            </div>
          ) : !data ? (
            <div className="py-8 text-center text-muted-foreground">
              No debug information available.
            </div>
          ) : (
            <>
              <Card className="flex-none">
                <CardHeader>
                  <CardTitle>Database Data</CardTitle>
                </CardHeader>
                <CardContent>
                  <JsonView src={data.dbData} />
                </CardContent>
              </Card>

              <Card className="flex-none">
                <CardHeader>
                  <CardTitle>Sing AG Data</CardTitle>
                </CardHeader>
                <CardContent>
                  <JsonView src={data.singAgData} />
                </CardContent>
              </Card>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
